var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 3,
    fill: "#177FF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3076 13.9487H23.1024L18.3076 9.15385V13.9487ZM12.205 7.84616H19.1794L24.4101 13.0769V23.5385C24.4101 24.0009 24.2264 24.4444 23.8995 24.7714C23.5725 25.0984 23.129 25.2821 22.6666 25.2821H12.205C11.7426 25.2821 11.2991 25.0984 10.9721 24.7714C10.6451 24.4444 10.4614 24.0009 10.4614 23.5385V9.58975C10.4614 8.62206 11.2373 7.84616 12.205 7.84616ZM13.0768 23.5385H14.8204V18.3077H13.0768V23.5385ZM16.564 23.5385H18.3076V16.5641H16.564V23.5385ZM20.0512 23.5385H21.7948V20.0513H20.0512V23.5385Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActive);
export default __webpack_public_path__ + "static/media/report_active.aefd085afe3615baec257e5a964bd8be.svg";
export { ForwardRef as ReactComponent };